import styled from 'styled-components'

export const TableButtonWrapper = styled.div`
  display: grid;
  align-items: center;

  color: ${({ theme }) => theme.colors.primary};
  margin-top: 20px;
`
export const TableRowWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1fr 1fr;
  align-items: center;
  justify-content: 'flex-start';

  width: 100%;

  gap: 20px;

  & :first-child {
    align-items: flex-start;
  }
  & :last-child {
    align-items: flex-end;
  }
`

export const Title = styled.div`
  font-size: 14px;
`
export const SubTitle = styled.div`
  font-size: 12px;
  font-weight: 300;
`
export const ColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const IPContainer = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  border-radius: 8px;
  gap: 8px;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.colors.backgroundLite};
`
